import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import axios from 'axios';
import { getCachedSiteSettings, setCachedSiteSettings } from '../utils/siteSettingsCache';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const FALLBACK_ABOUT_IMAGE =
  'https://images.unsplash.com/photo-1651495835942-ebe13feacaaa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxzdHVkZW50JTIwc3R1ZHlpbmclMjBuaWdodHxlbnwwfHx8fDE3NzU4MjM3MTl8MA&ixlib=rb-4.1.0&q=85';
const FALLBACK_ABOUT_STATS = [
  { value: '15.000+', label: 'Öğrenci' },
  { value: '50+', label: 'Uzman Mentor' },
  { value: '%95', label: 'Memnuniyet' },
];

export default function AboutPage() {
  const [settings, setSettings] = useState(() => getCachedSiteSettings());

  useEffect(() => {
    axios
      .get(`${API}/site-settings`)
      .then((response) => {
        const nextSettings = response.data || {};
        setSettings(nextSettings);
        setCachedSiteSettings(nextSettings);
      })
      .catch(() => {});
  }, []);

  const aboutText = settings?.about_text || '';
  const paragraphs = aboutText.split('\n').filter((paragraph) => paragraph.trim());
  const aboutImage = settings?.about_image_upload || settings?.about_image_url || FALLBACK_ABOUT_IMAGE;
  const aboutStats =
    Array.isArray(settings?.about_stats) && settings.about_stats.length > 0
      ? settings.about_stats
      : FALLBACK_ABOUT_STATS;

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Header />
      <main className="pt-24 pb-24 px-6">
        <div className="container mx-auto max-w-4xl">
          <div className="text-center mb-16">
            <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#B026FF]" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Hakkımızda
            </span>
            <h1
              className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-black mt-4"
              style={{ fontFamily: 'Outfit, sans-serif' }}
              data-testid="about-heading"
            >
              Karga Akademi'yi Tanıyın
            </h1>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start mb-16">
            <div>
              <img src={aboutImage} alt="Students" className="rounded-lg shadow-2xl" />
            </div>
            <div className="space-y-4">
              {paragraphs.map((paragraph, index) => (
                <p key={index} className="text-base leading-relaxed text-[#A1A1AA]">
                  {paragraph}
                </p>
              ))}
              {paragraphs.length === 0 && (
                <>
                  <p className="text-base leading-relaxed text-[#A1A1AA]">
                    Karga Akademi, Türkiye'nin önde gelen online mentorluk platformudur. Öğrencilerin sınav hazırlık süreçlerini daha verimli ve etkili hale getirmeyi amaçlamaktadır.
                  </p>
                  <p className="text-base leading-relaxed text-[#A1A1AA]">
                    Derece yapmış koçlarımız ve uzman PDR danışmanlarımız, her öğrencinin bireysel ihtiyaçlarına göre özelleştirilmiş çalışma programları hazırlar.
                  </p>
                  <p className="text-base leading-relaxed text-[#A1A1AA]">
                    Karga Akademi'nin farkı, her öğrenciye birebir ilgi göstermesi ve kişiselleştirilmiş bir öğrenme deneyimi sunmasıdır.
                  </p>
                </>
              )}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {aboutStats.map((stat, index) => (
              <div key={index} className="bg-[#0A0A0A] border border-white/10 rounded-lg p-8 text-center">
                <div className="text-4xl font-black text-[#B026FF] mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  {stat?.value || '-'}
                </div>
                <div className="text-[#A1A1AA] text-sm">{stat?.label || 'Bilgi'}</div>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
